/* eslint-disable react-hooks/exhaustive-deps */
import './datatable.scss'
import { DataGridPro } from '@mui/x-data-grid-pro'
import { useTranslation } from 'react-i18next'
import RefreshIcon from '@mui/icons-material/Refresh'
import { Box, IconButton, Link, Typography } from '@mui/material'
import CustomColumnMenu from '../datagrid/CustomColumnMenu'
import CustomLoadingOverlay from '../datagrid/CustomLoadingOverlay'
import dayjs from 'dayjs'

const DatatableClients = ({ clients, isLoading, refetch, onClick }) => {
  const { t } = useTranslation(['common'])

  const contractColumn = {
    field: 'contractUrl',
    headerName: t('common:contractUrl'),
    minWidth: 150,
    sortable: false,
    flex: 1,
  };

  const columns = [
    {
      field: 'tenant',
      headerName: t('common:email'),
      minWidth: 120,
      sortable: false,
      renderCell: (params) => {
        return (
          <Link title={params.value}>
            <Typography variant="number">{params.value}</Typography>
          </Link>
        )
      },
      flex: 1,
    },
    {
      field: 'initDate',
      headerName: t('common:initialContractDate'),
      valueGetter: (value) => {
        return dayjs(value).format('DD/MM/YYYY HH:mm')
      },
      minWidth: 150,
      sortable: false,
      flex: 1,
    },
    {
      field: 'endDate',
      headerName: t('common:endContractDate'),
      valueGetter: (value) => {
        return dayjs(value).format('DD/MM/YYYY HH:mm')
      },
      minWidth: 150,
      sortable: false,
      flex: 1,
    }
  ];

  // Add contract column if any client has a contractUrl
  if (clients && clients.length > 0 && clients.some((client) => client.contractUrl)) {
    columns.push(contractColumn);
  }

  return (
    <Box style={{ width: '100%', height: '100%' }}>
      <Box className="filter-bar">
        <IconButton sx={{ marginLeft: 'auto' }} onClick={refetch} disabled={isLoading} title={t('common:refresh')}>
          <RefreshIcon color="action" />
        </IconButton>
      </Box>
      <DataGridPro
        getRowHeight={() => 'auto'}
        getRowId={(row) => row._id || row.id}
        rows={Array.isArray(clients) ? clients : []}
        onRowClick={(params) => {
          if (onClick) {
            onClick(params.row)
          }
        }}
        columns={columns}
        slots={{
          columnMenu: CustomColumnMenu,
          loadingOverlay: CustomLoadingOverlay,
        }}
        hideFooter={true}
        autoHeight
        loading={isLoading}
      />
    </Box>
  )
}

export default DatatableClients
